<template>
  <div
    class="overlay-controller-parts"
    :class="[
      `overlay-controller-parts--${screenOrientationType}`,
      { 'overlay-controller-parts--is-pc': isPc },
    ]"
  >
    <seek-bar-parts
      class="overlay-controller-parts__seek-bar"
      v-if="hasRaceInfo && !isLiveNotStarted"
      v-model="videoTimesData"
      @handleTouchStartSeekBar="handleTouchStartSeekBar"
      @handleTouchEndSeekBar="handleTouchEndSeekBar"
    />

    <div class="overlay-controller-parts__inner">
      <div class="overlay-controller-parts__switch">
        <!-- 公式映像 / オンボード映像切り替えと、サーキットモード切り替えボタン -->
        <view-angle-toggle-switcher-parts
          :style="{
            visibility: hasRaceInfo,
          }"
          class="overlay-controller-parts__angle-switcher"
          :viewAngle="viewAngleStatus"
          :mapViewEnabled="mapViewEnabled"
          :angleSwitchEnabled="canAngleChange"
          :screenOrientationType="screenOrientationType"
          @viwAngleChange="toggleViewAngle"
          @viewMapMode="toggleMapMode"
        />

        <volume-controller-parts
          class="overlay-controller-parts__volume-controller"
          v-if="hasVolumeControl"
          @handleTouchEndSeekBar="handleTouchEndVolumeSeekBar"
          @handleVolumeMute="handleVolumeMute"
        />
      </div>

      <div class="overlay-controller-parts__buttons" v-show="!isLiveNotStarted">
        <!-- 30s 巻き戻し -->
        <button
          class="overlay-controller-parts__button overlay-controller-parts__button__prev30s"
          @click="prevVideo30s"
        >
          <img :src="require('@/assets/img/icon/video_controller_prev30s.svg')" alt="" />
        </button>
        <!-- 5s 巻き戻し -->
        <button
          class="overlay-controller-parts__button overlay-controller-parts__button__prev5s"
          @click="prevVideo5s"
        >
          <img :src="require('@/assets/img/icon/video_controller_prev5s.svg')" alt="" />
        </button>

        <!-- 再生 -->
        <button
          v-if="videoPausedStatus"
          class="overlay-controller-parts__button overlay-controller-parts__button__play"
          @click="playVideo"
        >
          <img :src="require('@/assets/img/icon/video_controller_play.svg')" alt="" />
        </button>

        <!-- 一時停止 -->
        <button
          v-if="!videoPausedStatus"
          class="overlay-controller-parts__button overlay-controller-parts__button__pause"
          @click="pauseVideo"
        >
          <img :src="require('@/assets/img/icon/video_controller_pause.svg')" alt="" />
        </button>

        <!-- 5秒 先送り -->
        <button
          class="overlay-controller-parts__button overlay-controller-parts__button__next5s"
          @click="nextVideo5s"
        >
          <img :src="require('@/assets/img/icon/video_controller_next5s.svg')" alt="" />
        </button>
        <!-- 30秒 先送り -->
        <button
          class="overlay-controller-parts__button overlay-controller-parts__button__next30s"
          @click="nextVideo30s"
        >
          <img :src="require('@/assets/img/icon/video_controller_next30s.svg')" alt="" />
        </button>

        <!-- スロー再生 -->
        <toggle-button-parts
          class="overlay-controller-parts__button overlay-controller-parts__button__slow"
          :enabled="videoSlowStatus"
          @toggle="slowVideo"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17 12L10 8V16L17 12Z" fill="white" fill-opacity="0.7" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18 19L15 19L15 21L18 21L18 19ZM20.5788 18.5515L20.8766 20.6359C22.4091 20.015 23.5638 18.6561 23.9 17L21.8293 17C21.6001 17.6485 21.1543 18.1946 20.5788 18.5515ZM22 14L24 14L24 10L22 10L22 14ZM20.8766 3.36408C22.4091 3.98505 23.5638 5.34391 23.9 7L21.8293 7C21.6001 6.35154 21.1543 5.8054 20.5788 5.44854L20.8766 3.36408ZM15 3L18 3L18 5L15 5L15 3Z"
              fill="white"
              fill-opacity="0.7"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 3L5 3C2.23858 3 -3.91405e-07 5.23858 -8.74228e-07 8L-2.27299e-06 16C-2.75581e-06 18.7614 2.23857 21 5 21L12 21L12 19L5 19C3.34314 19 2 17.6569 2 16L2 8C2 6.34315 3.34315 5 5 5L12 5L12 3Z"
              fill="white"
              fill-opacity="0.7"
            />
          </svg>
        </toggle-button-parts>
      </div>
      <div
        class="overlay-controller-parts__view-tool"
        :class="{ 'overlay-controller-parts__view-tool--pc': isPc }"
      >
        <div class="overlay-controller-parts__view-mode" v-show="!isLiveNotStarted">
          <!-- ビデオ最大表示切り替え -->
          <button
            class="overlay-controller-parts__button overlay-controller-parts__button__full-scale"
            @click="changeFullScaleVideo"
          >
            <img
              v-if="!videoFullScaleStatus"
              :src="require('@/assets/img/icon/video_controller_fullscale.svg')"
              alt=""
            />
            <img
              v-else
              :src="require('@/assets/img/icon/video_controller_un_fullscale.svg')"
              alt=""
            />
          </button>

          <!-- フルスクリーンボタン -->
          <button
            class="overlay-controller-parts__button overlay-controller-parts__button__fullscreen"
            @click="changeFullscreen"
          >
            <img
              v-if="
                screenOrientationType.indexOf('portrait') !== -1 ||
                (lockOrientation !== undefined && viewContentsMode !== 'single')
              "
              :src="require('@/assets/img/icon/video_controller_fullscreen.svg')"
              alt=""
            />
            <img
              v-else
              :src="require('@/assets/img/icon/video_controller_un_fullscreen.svg')"
              alt=""
            />
          </button>
          <live-icon-parts
            class="overlay-controller-parts__live"
            :isLive="liveEnabled"
            @onLiveClicked="onLiveClicked"
          />
        </div>
      </div>

      <div class="overlay-controller-parts__view-small">
        <!-- フルスクリーンボタン -->
        <button
          class="overlay-controller-parts__button overlay-controller-parts__button__fullscreen"
          @click="changeFullscreen"
        >
          <img
            v-if="screenOrientationType.indexOf('portrait') !== -1"
            :src="require('@/assets/img/icon/video_controller_fullscreen.svg')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/img/icon/video_controller_un_fullscreen.svg')"
            alt=""
          />
        </button>
        <live-icon-parts
          class="overlay-controller-parts__live"
          :isLive="liveEnabled"
          @onLiveClicked="onLiveClicked"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import SeekBarParts from '@/components/RaceVideoPage/RaceVideoPane/parts/SeekBarParts.vue'
import LiveIconParts from '@/components/RaceVideoPage/RaceVideoPane/parts/LiveIconParts.vue'
import ViewAngleToggleSwitcherParts from '@/components/RaceVideoPage/RaceVideoPane/parts/ViewAngleToggleSwitcherParts.vue'
import ToggleButtonParts from '@/components/RaceVideoPage/RaceVideoPane/parts/ToggleButtonParts.vue'
import VolumeControllerParts from '@/components/RaceVideoPage/RaceVideoPane/parts/VolumeControllerParts.vue'
import { VideoStatusType } from '@/components/hook/useVideoPlayer'
import { ViewAngleType } from '@/store/stores/pageStore/RaceVideoPage/RaceVideoPageStore'
import { LockOrientationType } from '@/views/RaceVideoPage/RaceVideoPage.vue'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * レース動画再生画面 動画プレーヤー オーバーレイコンポーネント
 */
export default defineComponent({
  name: 'OverlayControllerParts',
  components: {
    SeekBarParts,
    LiveIconParts,
    ViewAngleToggleSwitcherParts,
    ToggleButtonParts,
    VolumeControllerParts,
  },
  props: {
    /**
     * シークバー用再生時間データ
     */
    videoTimes: {
      type: Object as PropType<VideoStatusType>,
      required: false,
    },
    /**
     * LIVE中継フラグ
     */
    liveEnabled: {
      type: Boolean,
      required: true,
    },
    /**
     * ライブ配信が未配信かどうか
     */
    isLiveNotStarted: {
      type: Boolean,
      required: true,
    },
    /**
     * 表示アングルデータ
     */
    viewAngle: {
      type: String,
      required: true,
    },
    /**
     * 表示コンテンツモード
     */
    viewMode: {
      type: String,
      required: true,
    },
    /**
     * ビデオフルスケールフラグ
     */
    videoFullScale: {
      type: Boolean,
      default: false,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 画面固定
     */
    lockOrientation: {
      type: String as PropType<LockOrientationType>,
    },
    /**
     * ビデオ一時停止フラグ
     */
    videoPaused: {
      type: Boolean,
      default: false,
    },
    /**
     * ビデオスロー再生フラグ
     */
    videoSlow: {
      type: Boolean,
      default: false,
    },
    /**
     * レース情報を取得済みかどうか
     */
    isFetchedRaceInfo: {
      type: Boolean,
      default: false,
    },
    /**
     * 公式映像/オンボード映像の切り替えが可能かどうか
     */
    isAngleChangeAvailable: {
      type: Boolean,
      default: false,
    },
    /**
     * MAP表示フラグ
     */
    mapViewEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 音量調整機能
     */
    hasVolumeControl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const isPc = DeviceInfo.isForPC()
    const videoTimesData = computed({
      get: () => props.videoTimes,
      set: (val) => context.emit('update:videoTimes', val),
    })
    const viewAngleStatus = computed(() => props.viewAngle)
    const screenLandScape = computed(() => props.screenOrientationType.indexOf('landscape') !== -1)
    const viewContentsMode = computed(() => props.viewMode)
    const videoPausedStatus = computed(() => props.videoPaused)
    const videoSlowStatus = computed(() => props.videoSlow)
    const hasRaceInfo = computed(() => props.isFetchedRaceInfo)
    const canAngleChange = computed(() => props.isAngleChangeAvailable)
    const videoFullScaleStatus = computed(() => props.videoFullScale)

    return {
      isPc,
      videoTimesData,
      viewAngleStatus,
      screenLandScape,
      viewContentsMode,
      videoPausedStatus,
      videoSlowStatus,
      hasRaceInfo,
      canAngleChange,
      videoFullScaleStatus,
    }
  },
  methods: {
    /**
     * 表示アングル変更
     * @param angle: 'race' or 'player'
     */
    toggleViewAngle(angle: ViewAngleType): void {
      this.$emit('viwAngleChange', angle)
    },
    /**
     * 簡易マップ表示変更
     */
    toggleMapMode(): void {
      this.$emit('viewMapMode')
    },

    /**
     * 表示モード変更
     * @param mode
     */
    changeViewMode(mode: string): void {
      let rt = ''
      const orgMode = this.viewContentsMode
      if (this.screenLandScape) {
        rt = mode !== this.viewContentsMode ? mode : 'single'
      } else if (mode === 'highlight') {
        rt = this.viewContentsMode === 'highlight' ? 'telemetry' : 'highlight'
      } else if (mode === 'telemetry') {
        rt = this.viewContentsMode === 'telemetry' ? 'highlight' : 'telemetry'
      }
      this.$emit('viewModeChange', rt, orgMode)
    },

    /**
     * 全画面表示変更
     */
    changeFullscreen(): void {
      this.$emit('fullscreenChange')
    },
    /**
     * VIDEOフルスケール表示切り替え
     */
    changeFullScaleVideo(): void {
      this.$emit('fullScaleVideo')
    },

    /**
     * ビデオ 再生 処理
     */
    playVideo(): void {
      this.$emit('videoPlayPauseChange', false)
    },

    /**
     * ビデオ 一時停止 処理
     */
    pauseVideo(): void {
      this.$emit('videoPlayPauseChange', true)
    },

    /**
     * ビデオ 5秒巻き戻し 処理
     */
    prevVideo5s(): void {
      this.$emit('videoPlayChangeCurrentTime', -5.0)
    },

    /**
     * ビデオ 30秒巻き戻し 処理
     */
    prevVideo30s(): void {
      this.$emit('videoPlayChangeCurrentTime', -30.0)
    },

    /**
     * ビデオ 5秒先送り 処理
     */
    nextVideo5s(): void {
      this.$emit('videoPlayChangeCurrentTime', 5.0)
    },

    /**
     * ビデオ 30秒先送り 処理
     */
    nextVideo30s(): void {
      this.$emit('videoPlayChangeCurrentTime', 30.0)
    },

    /**
     * ビデオ スロー再生 処理
     */
    slowVideo(): void {
      this.$emit('videoSlowChange')
    },
    /**
     * LIVEボタン 処理
     */
    onLiveClicked(): void {
      this.$emit('onLiveClicked')
    },
    /**
     * シークバー touchStart時イベント通知
     */
    handleTouchStartSeekBar(): void {
      this.$emit('handleTouchStartSeekBar')
    },
    /**
     * シークバー touchEnd時イベント通知
     */
    handleTouchEndSeekBar(): void {
      this.$emit('handleTouchEndSeekBar')
    },
    /**
     * 音声シークバー イベント通知
     * @param volumeLevel 音量
     */
    handleTouchEndVolumeSeekBar(volumeLevel: number) {
      this.$emit('handleTouchEndVolumeSeekBar', volumeLevel)
    },
    /**
     * 音声ミュート イベント通知
     * @param isMute ミュートしているか
     */
    handleVolumeMute(isMute: boolean): void {
      this.$emit('handleVolumeMute', isMute)
    },
  },
})
</script>

<style lang="scss" scoped>
.overlay-controller-parts {
  position: relative;
  background: rgba(0, 0, 0, 70%);

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 720px;
    padding: 8px 12px 0 11px;
    margin: 0 auto;
    height: 81px;

    @media screen and (max-width: 360px) {
      padding: 8px 6px 0;
    }

    @media screen and (max-width: 290px) {
      padding: 8px 10px 0 18px;

      &::before {
        display: none;
      }
    }

    @media screen and (min-width: 640px) {
      gap: 0.65%;
    }
  }

  &--is-pc {
    .overlay-controller-parts {
      &__inner {
        max-width: none;
      }
    }
  }

  &__switch {
    display: flex;
  }

  &__live {
    margin-left: 12px;

    @media screen and (max-width: 360px) {
      margin-left: 0;
    }

    @media screen and (min-width: 640px) {
      margin-left: 6px;
    }
  }

  &__buttons,
  &__view-mode {
    display: none;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;

    @media screen and (min-width: 640px) {
      display: flex;
    }
  }

  &__buttons {
    @media screen and (min-width: 800px) {
      padding-left: 16px;
    }
  }

  &__view-mode {
    gap: 8px;
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 2px;
    margin-left: 0;

    svg {
      width: 24px;
    }

    &__prev5s,
    &__next30s {
      margin-left: 10px;
    }

    &__next5s,
    &__prev5s {
      width: 36px;
      height: 36px;
    }

    &__play,
    &__pause {
      width: 48px;
      height: 48px;
      margin-left: 12px;

      svg {
        width: 48px;
      }
    }

    &__next5s {
      margin-left: 12px;
    }

    &__slow {
      margin-left: 10px;
    }

    &__highlight {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      margin-left: 0;
    }

    &__full-scale {
      display: none;
    }

    &__fullscreen {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
    }
  }

  &__volume {
    &-controller {
      margin-left: 6px;
    }
  }

  &__view {
    &-tool {
      display: none;
      align-items: center;
      justify-content: flex-end;

      @media screen and (min-width: 640px) {
        display: flex;
      }

      &--pc {
        padding-left: 0;
        margin-left: auto;

        @media screen and (min-width: 1050px) {
          width: 100%;
          max-width: 344px;

          .overlay-controller-parts__view-mode {
            gap: 12px;
          }
        }
      }
    }

    &-small {
      display: flex;
      align-items: center;
      margin-left: auto;

      @media screen and (max-width: 360px) {
        margin-left: 0;
      }

      @media screen and (min-width: 640px) {
        display: none;
      }
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    margin-top: auto;
    background: none;
    gap: 0;
    box-sizing: border-box;

    &::before {
      position: fixed;
      left: 50%;
      bottom: 0;
      display: block;
      content: '';
      width: 100vw;
      height: 78px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);
      z-index: 0;
      transform: translateX(-50%);
    }

    &__inner {
      padding: 0 10px;
    }

    .overlay-controller-parts {
      &__angle-switcher {
        transform: none;
        margin-left: 0;

        @media screen and (max-width: 710px) {
          left: 12px;
        }

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }

      &__buttons {
        position: relative;
      }

      &__view {
        &-tool {
          position: relative;
          margin-left: 6px;
        }
      }

      &__button {
        &__full-scale {
          display: flex;
        }
      }
    }

    &.overlay-controller-parts--is-pc {
      .overlay-controller-parts {
        &__buttons {
          padding-left: 34px;
        }

        &__button {
          &__prev5s,
          &__next30s,
          &__slow {
            margin-left: 16px;
          }

          &__play,
          &__pause,
          &__next5s {
            margin-left: 12px;
          }
        }

        &__inner {
          @media screen and (min-width: 741px) {
            padding: 0 40px;
          }
        }
      }
    }

    @media screen and (max-width: 710px) {
      .overlay-controller-parts {
        &__button {
          &__prev5s,
          &__next30s {
            margin-left: 6px;
          }

          &__play,
          &__pause,
          &__next5s {
            margin-left: 8px;
          }
        }

        &__view {
          &-tool {
            width: auto;
          }

          &-mode {
            gap: 6px;
          }
        }
      }
    }

    @media screen and (max-width: 650px) {
      .overlay-controller-parts {
        &__button {
          &__prev5s,
          &__next30s,
          &__play,
          &__pause,
          &__next5s {
            margin-left: 2px;
          }

          &__slow,
          &__full-scale {
            display: none;
          }
        }

        &__view {
          &-mode {
            gap: 2px;
          }
        }
      }
    }
  }
}
</style>
